import { css } from '@emotion/react';

export const drawer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const drawerContent = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 40px 20px;
  max-width: 550px;
  text-align: center;
  gap: 20px;
`;
